import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TableConfig } from "../../../shared/util/table-config.utils";
import { Tool } from "../../model/tool.model";
import { Log } from "ng2-logger";
import * as _ from "lodash";

@Component({
    selector: 'app-tool-backup-table',
    templateUrl: './tool-backup-table.component.html',
    styleUrls: ['./tool-backup-table.component.scss']
})
export class ToolBackupTableComponent implements OnChanges {
    _logger = Log.create(ToolBackupTableComponent.name);
    @Input() toolBackups: Tool[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() selectableRows = true;
    @Input() hasPagination = false;
    @Input() showFilters = true;
    @Input() isMaterial = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() checkedTools = new EventEmitter<any>();

    _filteredBackups = [];

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolBackups']) {
            this._filteredBackups = this.toolBackups;
        }
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', this.tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', this.tableConfig);
        if (this.tableConfig.filters && this.tableConfig.filters.length === 1) {
            this.filteredBackups = _.filter(this.toolBackups,
                (item: Tool) => item.name.toLowerCase().indexOf(tableConfig.filters[0].value.toLowerCase()) !== -1 ||
                    item.mainLine.name.toLowerCase().indexOf(tableConfig.filters[0].value.toLowerCase()) !== -1);
        } else {
            this.filteredBackups = this.toolBackups;
        }

        this.filterChange.emit(tableConfig);
    }

    buildBackupName(tool: Tool) {
        return `${tool.name} - ${tool.mainLine.name}`;
    }

    checkTools(tool: Tool) {
        this._logger.info('checkTools:: Selected backup', tool);
        tool.selected = !tool.selected;
        const toolForSelection: any = _.filter(this.toolBackups, {id: tool.id});
        toolForSelection.selected = !toolForSelection.selected;
        const selectedBackups = _.filter(this.toolBackups, {selected: true});
        this.tableConfig.pager.selected = selectedBackups.length;
        this.checkedTools.emit(_.map(selectedBackups, 'id'));
    }

    isChecked(tool: Tool) {
        return tool.selected;
    }

    get filteredBackups() {
        return this._filteredBackups;
    }

    set filteredBackups(filtered) {
        this._filteredBackups = filtered;
    }

}
